import { render, staticRenderFns } from "./FormsHome.vue?vue&type=template&id=e442a844"
import script from "./FormsHome.vue?vue&type=script&lang=js"
export * from "./FormsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports